import { createAsyncThunk } from '@reduxjs/toolkit';

import ResponseError from '@/errors/responseError';
import authModel from '@/models/auth';
import billingModel from '@/models/billing';
import paymentModel from '@/models/payment';
import signatureModel from '@/models/signature';
import userModel from '@/models/user';

export const fetchCurrencies = createAsyncThunk(
	'profile/fetchCurrencies',
	async (_, { rejectWithValue }) => {
		try {
			return await paymentModel.getCurrencies();
		} catch (error) {
			if (error instanceof ResponseError) {
				return rejectWithValue({ status: error.status, data: error.data });
			}

			throw error;
		}
	}
);

export const fetchUser = createAsyncThunk(
	'profile/fetchUser',
	async (_, { rejectWithValue }) => {
		try {
			const response = await userModel.me();

			localStorage.removeItem('googleAdId');
			localStorage.setItem('user', JSON.stringify(response));
			signatureModel.clearLocalSignatures();

			return response;
		} catch (error) {
			if (error instanceof ResponseError) {
				return rejectWithValue({ status: error.status, data: error.data });
			}
			throw error;
		}
	}
);

export const updateUser = createAsyncThunk(
	'profile/updateUser',
	async (values, { rejectWithValue, dispatch }) => {
		try {
			const response = await userModel.update(values);

			if (!response.success) {
				throw new Error(response.statusText);
			}

			dispatch(fetchUser());

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const deleteUser = createAsyncThunk(
	'profile/deleteUser',
	async (_, { rejectWithValue }) => {
		try {
			const response = await userModel.delete();

			localStorage.removeItem('user');

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const updateTaxInformation = createAsyncThunk(
	'profile/updateTaxInformation',
	async (values, { rejectWithValue, dispatch }) => {
		try {
			const response = await billingModel.update(values);

			if (!response.success) {
				throw new Error(response.statusText);
			}

			await dispatch(fetchUser()).unwrap();

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const signUp = createAsyncThunk(
	'profile/signUp',
	async (payload, { rejectWithValue }) => {
		try {
			const response = await userModel.create(payload);

			return response;
		} catch (error) {
			if (error instanceof ResponseError) {
				return rejectWithValue(error);
			}

			throw error;
		}
	}
);

export const logout = createAsyncThunk('profile/logout', async () => {
	const response = await authModel.logout();

	localStorage.removeItem('user');

	return response;
});

export const fetchBillingInfo = createAsyncThunk(
	'profile/fetchBillingInfo',
	async (_, { rejectWithValue }) => {
		try {
			return await billingModel.getInfo();
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);
